module.exports = __webpack_public_path__ + "static/media/instagram-es.c64eebec.png";